import { csx, keyframes } from '@vtex/admin-ui'

const pulse = keyframes({
  '0%, 100%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0.5,
  },
})

export const wrapper = (
  width: number | string,
  height: number | string,
  withBorder: boolean
) =>
  csx({
    border: withBorder ? '$neutral' : 'none',
    borderRadius: '4px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: `${height}px !important`,
    width: `${width}px !important`,
    minHeight: `${height}px !important`,
    minWidth: `${width}px !important`,
    position: 'relative',
  })

export const image = csx({
  objectFit: 'contain',
  maxWidth: '100%',
  maxHeight: '100%',
})

export const placeholder = (width: number | string, height: number | string) =>
  csx({
    position: 'absolute',
    width: `${width}px`,
    height: `${height}px`,
    backgroundColor: '$gray20',
    borderRadius: '$base',
    animation: `${pulse.name} 1.5s ease-in-out infinite`,
    zIndex: -1,
  })
